"use strict";

// modules
import Cookies from "../modules/cookies";
import Vue from "vue/dist/vue.common.js";
import VueYouTubeEmbed from "vue-youtube-embed";
import "../modules/election-map";

// vuex
import store from "./vuex/store";

// vue services
import CSRFService from "./services/csrf";

// vue instances
import DirectoryHeader from "./instances/directory-header";
import DatabaseSearch from "./instances/database-search";
import DistrictBillboard from "./instances/district-billboard";
import EventListing from './instances/event-listing';
import Header from "./instances/header";
import Nav from "./instances/nav";
import Notes from "./instances/notes";
import ProfileIntro from "./instances/profile-intro";
import SessionForm from "./instances/session-form";
import UserSubmission from "./instances/user-submission";
import AccountabilitySurvey from "./instances/accountability-survey";
import Signup from "./instances/signup";
import Squads from "./instances/squads";
import VideoModal from "./instances/video-modal";
import Rotator from "./instances/rotator";
import Alert from "./instances/alert";
import { router } from "./instances/squads";

Vue.use(VueYouTubeEmbed);

class VueOrchestrator {
  constructor() {
    this.setCsrfToken().then(() => this.mountVueInstances());
  }

  setCsrfToken() {
    let csrf_token = Cookies.get("csrf_token");
    if (!!csrf_token) {
      store.commit("setCsrfToken", csrf_token);
      return Promise.resolve(csrf_token);
    } else {
      return CSRFService.get().then((response) => {
        store.commit("setCsrfToken", response);
        Promise.resolve(response);
      });
    }
  }

  mountVueInstances() {
    this.mount(Header, "#Header");
    this.mount(Nav, "#Nav");
    this.mount(DirectoryHeader, "#DirectoryHeader");
    this.mount(DistrictBillboard, "#DistrictBillboard");
    this.mount(Notes, "#Notes");
    this.mount(DatabaseSearch, "#DatabaseSearch");
    this.mount(ProfileIntro, "#ProfileIntro");
    this.mount(SessionForm, "#SessionForm");
    this.mount(UserSubmission, "#UserSubmission");
    this.mount(AccountabilitySurvey, "#AccountabilitySurvey");
    this.mount(Signup, "#Signup");
    this.mount(Squads, "#Squads", { router });
    this.mount(Alert, ".Alert");
    this.mount(Rotator, ".Slider");
    this.mount(EventListing, "#EventListing");
    // FIXME - selector is fragile, doesn't support multiple instances.
    this.mount(VideoModal, "#VideoModal");
  }

  mount(instance, selector, config = {}) {
    const elem = document.querySelectorAll(selector);
    if (!!elem.length) {
      [].forEach.call(elem, (el) => {
        new instance(config).$mount(el);
      });
    }
  }
}

export default new VueOrchestrator();



// WEBPACK FOOTER //
// ./app/javascript/vue/main.js